import { render, staticRenderFns } from "./vue-tabs.vue?vue&type=template&id=7e30a791"
import script from "./vue-tabs.vue?vue&type=script&lang=js"
export * from "./vue-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/josh/CODE/king-living/king-living-outlet-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e30a791')) {
      api.createRecord('7e30a791', component.options)
    } else {
      api.reload('7e30a791', component.options)
    }
    module.hot.accept("./vue-tabs.vue?vue&type=template&id=7e30a791", function () {
      api.rerender('7e30a791', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/vue-tabs.vue"
export default component.exports